/* eslint-disable no-console */
function Utility() {
  const data = {
    // RES_SERVER: 'https://bio-cloud.aptbiotech.com:6095', // 101.133.131.230
    // userApi: 'https://bio-cloud.aptbiotech.com:6080',
    RES_SERVER: process.env.VUE_APP_RES_URL,
    userApi: process.env.VUE_APP_URL,
    FILE_ICON: {
      xls: "mdi-file-excel-outline",
      xlsx: "mdi-file-excel-outline",
      doc: "mdi-file-word-outline",
      docx: "mdi-file-word-outline",
      ppt: "mdi-file-powerpoint-outline",
      pptx: "mdi-file-powerpoint-outline",
      html: "mdi-language-html5",
      htm: "mdi-language-html5",
      js: "mdi-language-javascript",
      css: "mdi-language-css3",
      md: "mdi-file-code-outline",
      pdf: "mdi-file-pdf-outline",
      jpg: "mdi-file-image-outline",
      jpeg: "mdi-file-image-outline",
      png: "mdi-file-image-outline",
      txt: "mdi-note-text-outline",
      csv: "mdi-file-excel-outline",
      json: "mdi-json",
      none: "mdi-file-question-outline",
    },
  };
  const methods = {
    avg(list, attr) {
      return !list || list.length == 0
        ? 0
        : Number((this.sum(list, attr) / list.length).toFixed(2));
    },
    clone(src) {
      return !src ? src : JSON.parse(JSON.stringify(src));
    },
    colorRGB(src) {
      let c1 = src.toLowerCase();
      var rgbs = [];
      for (var i = 1; i < 7; i += 2) {
        rgbs.push(parseInt("0x" + c1.slice(i, i + 2)));
      }
      return "RGB(" + rgbs.join(",") + ")";
    },
    createObj(express) {
      // a.b.c[0][1].d
      let ss = [];
      let s1 = express.split(".");
      s1.forEach((s) => {
        let s2 = s.split("[");
        s2.forEach((item) => ss.push(item.replace("]", "")));
      });
      let ret = {};
      let preExpress = "ret";
      for (let i = 0, l = ss.length; i < l; i++) {
        let a = ss[i],
          b = ss[i + 1];
        if (!b) break;
        let na = isNaN(a),
          nb = isNaN(b);
        if (na && nb) {
          eval(`${preExpress}.${a}={}`);
          preExpress += `.${a}`;
        } else if (na && !nb) {
          eval(`${preExpress}.${a}=[]`);
          preExpress += `.${a}`;
        } else if (!na && !nb) {
          eval(`${preExpress}[${a}]=[]`);
          preExpress += `[${a}]`;
        } else if (!na && nb) {
          eval(`${preExpress}[${a}]={}`);
          preExpress += `[${a}]`;
        }
      }
      //console.log(express, ss, ret);
      return ret;
    },
    deepMerge() {
      // 深度合并对象
      let src = arguments[0];
      for (let i = 1; i < arguments.length; i++) {
        let tar = arguments[i];
        for (let key in tar) {
          // if (Array.isArray(src[key])) {
          //   src[key].forEach((item, index) => this.deepMerge(item, tar[key][index]))
          // } else
          src[key] =
            src[key] && src[key].toString() === "[object Object]"
              ? this.deepMerge(src[key], tar[key])
              : (src[key] = tar[key]);
        }
      }
      return src;
    },
    dragDialog(id) {
      let cardEl = document.getElementById(id);
      let el = cardEl.getElementsByClassName("r-dialog-drag-title")[0];
      if (!el) {
        let newEl = document.createElement("div");
        newEl.setAttribute("class", "teal darken-3 pt-8 r-dialog-drag-title");
        newEl.style.cursor = "move";
        cardEl.insertAdjacentElement("afterBegin", newEl);
        el = newEl;
      }
      let dialogEl = el.parentElement.parentElement;
      dialogEl.style.transition = "unset";
      dialogEl.style.position = "absolute";
      let layoutEl = dialogEl.parentElement;
      el.onmousedown = (e) => {
        layoutEl.onselectstart = () => false;
        let disX = e.clientX - dialogEl.offsetLeft + 24,
          disY = e.clientY - dialogEl.offsetTop + 24;
        let left, top;
        layoutEl.onmousemove = (e) => {
          (left = e.clientX - disX), (top = e.clientY - disY);
          dialogEl.style.left = left + "px";
          dialogEl.style.top = top + "px";
        };
        layoutEl.onmouseup = () => {
          layoutEl.onmousemove = null;
          layoutEl.onmouseup = null;
        };
        layoutEl.onmouseout = () => {
          layoutEl.onmousemove = null;
          layoutEl.onmouseout = null;
        };
      };
    },
    findById(arr, id, idField = "ID") {
      if (!id) throw new Error("argument id is null");
      for (let i = 0, l = arr.length; i < l; i++) {
        let item = arr[i];
        if (id == item[idField]) return item;
        if (item.children && item.children.length) {
          let ret = this.findById(item.children, id, idField);
          if (ret) return ret;
        }
      }
    },
    // findNode (el, nodeName) { // 查找节点
    //   let finder = (children) => {
    //     for (let i = 0, l = children.length; i < l; i++) {
    //       if (children[i].nodeName.toLowerCase() == nodeName.toLowerCase()) return children[i];
    //       if (children[i].children && children[i].children.length) return finder(children[i].children);
    //     }
    //   }
    //   return finder(el.children);
    // },
    flatTree(arr) {
      let list = this.clone(arr);
      let ret = [];
      let flatChildren = (children) => {
        for (let i = 0, l = children.length; i < l; i++) {
          let children2 = children[i].children;
          if (children2 && children2.length) {
            flatChildren(children2);
            delete children[i].children;
            ret.push(children[i]);
          } else {
            delete children[i].children;
            ret.push(children[i]);
          }
        }
      };
      flatChildren(list);
      return ret;
    },
    fmtAmount(value) {
      if (!value) return value;
      let sv = String(value),
        dotIndex = sv.indexOf(".");
      if (dotIndex == -1) return sv.replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
      let sv1 = sv.substring(0, dotIndex),
        sv2 = sv.substring(dotIndex, sv.length);
      return sv1.replace(/(\d)(?=(?:\d{3})+$)/g, "$1,") + sv2;
    },
    fmtCoder(value, coder) {
      if (!coder || !coder.length) return value;
      let item = coder.find((r) => r.code == value);
      return !item ? value : item.name;
    },
    fmtDt(value, fmt) {
      // 数据库格式 转换为 显示格式
      if (!value) return "";
      value = String(value);
      let parts = [];
      const len = value.length;
      if (len === 8) {
        parts = [
          value.substr(0, 4),
          value.substr(4, 2),
          value.substr(6),
          "00",
          "00",
          "00",
        ];
      } else if (len === 14) {
        parts = [
          value.substr(0, 4),
          value.substr(4, 2),
          value.substr(6, 2),
          value.substr(8, 2),
          value.substr(10, 2),
          value.substr(12),
        ];
      } else if (len === 6) {
        parts = [
          "1970",
          "01",
          "01",
          value.substr(0, 2),
          value.substr(2, 2),
          value.substr(4),
        ];
      } else return value;
      if (!fmt) {
        if (len === 14) fmt = "yyyy-MM-dd HH:mm:ss";
        else if (len === 6) fmt = "HH:mm:ss";
        else fmt = "yyyy-MM-dd";
      }
      fmt = fmt.toLowerCase();
      if (fmt === "yyyy-mm-dd") return `${parts[0]}-${parts[1]}-${parts[2]}`;
      else if (fmt === "yyyy-mm-dd hh:mm:ss")
        return `${parts[0]}-${parts[1]}-${parts[2]} ${parts[3]}:${parts[4]}:${parts[5]}`;
      else if (fmt === "hh:mm:ss") return `${parts[3]}:${parts[4]}:${parts[5]}`;
      else if (fmt === "hh:mm") return `${parts[3]}:${parts[4]}`;
      else if (fmt === "yyyy-mm-dd hh:mm")
        return `${parts[0]}-${parts[1]}-${parts[2]} ${parts[3]}:${parts[4]}`;
      else return value;
    },
    fmtDt2(value) {
      // 输入格式 转换为 日期类型
      value = String(value);
      if (value.indexOf("-") != -1) {
        let ps = value.split("-"),
          p0 = ps[0],
          p1 = ps[1],
          p2 = ps[2];
        if (isNaN(p0) || isNaN(p1) || isNaN(p2)) return null;
        return new Date(ps[0], parseInt(ps[1]) - 1, ps[2]);
      }
      // 8位[20200619->2020-06-19]
      if (value.length == 8) {
        let p0 = value.substr(0, 4),
          p1 = value.substr(4, 2),
          p2 = value.substr(6);
        if (isNaN(p0) || isNaN(p1) || isNaN(p2)) return null;
        return new Date(p0, p1 - 1, p2);
      }
      // 7位[2020619->2020-06-19]
      if (value.length == 7) {
        let p0 = value.substr(0, 4),
          p1 = value.substr(4, 2);
        if (isNaN(p0) || isNaN(p1)) return null;
        if (p1 > 9 && p1 < 13) {
          let p2 = value.charAt(6);
          if (isNaN(p2)) return null;
          return new Date(p0, p1 - 1, p2);
        } else {
          p1 = value.substr(4, 1);
          let p2 = value.substr(5, 2);
          if (isNaN(p1) || isNaN(p2)) return null;
          return new Date(p0, p1 - 1, p2);
        }
      }
      // 6位[200619->2020-06-19]
      if (value.length == 6) {
        let p0 = value.substr(0, 2);
        if (isNaN(p0)) return null;
        p0 = String(new Date().getFullYear()).substr(0, 2) + p0;
        let p1 = value.substr(2, 2),
          p2 = value.substr(4, 2);
        if (isNaN(p1) || isNaN(p2)) return null;
        return new Date(p0, p1 - 1, p2);
      }
      // 5位[20619->2020-06-19]
      if (value.length == 5) {
        let p0 = value.substr(0, 2);
        if (isNaN(p0)) return null;
        p0 = String(new Date().getFullYear()).substr(0, 2) + p0;
        let p1 = value.substr(2, 2);
        if (isNaN(p1)) return null;
        if (p1 > 9 && p1 < 13) {
          let p2 = value.charAt(4);
          if (isNaN(p2)) return null;
          return new Date(p0, p1 - 1, p2);
        } else {
          p1 = value.substr(2, 1);
          let p2 = value.substr(3, 2);
          if (isNaN(p1) || isNaN(p2)) return null;
          return new Date(p0, p1 - 1, p2);
        }
      }
      // 4位[1211->2020-12-11][0619->2020-06-19]
      if (value.length == 4) {
        let p1 = value.substr(0, 2),
          p2 = value.substr(2, 2);
        if (isNaN(p1) || isNaN(p2)) return null;
        let p0 = new Date().getFullYear();
        return new Date(p0, p1 - 1, p2);
      }
      // 3位[619->2020-06-19][121->2020-12-01]
      if (value.length == 3) {
        let p1 = value.substr(0, 2);
        if (isNaN(p1)) return null;
        let p0 = new Date().getFullYear();
        if (p1 > 9 && p1 < 13) {
          let p2 = value.charAt(2);
          if (isNaN(p2)) return null;
          return new Date(p0, p1 - 1, p2);
        } else {
          p1 = value.charAt(0);
          let p2 = value.substr(1, 2);
          if (isNaN(p1) || isNaN(p2)) return null;
          return new Date(p0, p1 - 1, p2);
        }
      }
      return null;
    },
    fmtExpress(express, data) {
      // 将${xx} 转换为值
      if (!data || !express || express.indexOf("${") == -1) return express;
      for (let k in data)
        if (express.indexOf("${" + k + "}") != -1)
          express = express.replace(new RegExp("\\${" + k + "}", "g"), data[k]);
      return express;
    },
    fmtExpress2(str, vp) {
      // 字符串模板格式化，变量： ${xx}, 循环：#for(xx in xx)...#end [TODO 待确定是否采取此种方式]
      /**
       ${xx}  --> /\${[^\\${}]+}/
       #for(xx in xx) ... #end   -->  /#for[^#for][\s\S]*#end/
       #for(xx in xx) --> /^#for\(.+\sin\s.+\)/
       */
      if (this.isNull(vp)) return null;
      let m;
      while ((m = str.match(/\${[^\\${}]+}/)) != null) {
        let sc = m[0].substring(2, m[0].length - 1);
        let v = "";
        try {
          v = eval("vp." + sc);
        } catch (ex) {
          //
          console.error(ex.message);
        }
        // 如果转换后的值中还存在${,则替换为：$ {,以免出现死循环
        if (v.indexOf("${") != -1) v = v.replaceAll("${", "$ {");
        str = str.replace(m[0], v);
      }
      return str;
    },
    fmtPeriod(value) {
      // 202005 -> 2020年5月
      return this.parseDt(
        new Date(this.fmtDt(String(value) + "01", "yyyy-MM-dd")),
        "yyyy年M月"
      );
    },
    fmtPeriod2(value) {
      // 202012->202012
      if (!value) return null;
      return this.parseDt(
        new Date(
          this.fmtDt(
            this.replaceAll(String(value), "-", "") + "01",
            "yyyy-MM-dd"
          )
        ),
        "yyyy-MM"
      );
    },
    getDates(period) {
      // 根据期间获取开始日期与截止日期
      period = String(period);
      let year, month;
      if (period.indexOf("-") == -1) {
        year = period.substr(0, 4);
        month = period.substr(4);
      } else {
        year = period.substr(0, 4);
        month = period.substr(5);
      }
      let fromDt = Number(`${year}${month}01`);
      let nextDate = new Date(year, month - 1, 1);
      nextDate.setMonth(nextDate.getMonth() + 1);
      nextDate.setDate(nextDate.getDate() - 1);
      let nextYear = nextDate.getFullYear(),
        nextMonth = nextDate.getMonth() + 1;
      let toDt = Number(
        `${nextYear}${
          nextMonth < 10 ? `0${nextMonth}` : nextMonth
        }${nextDate.getDate()}`
      );
      return [fromDt, toDt];
    },
    groupArray(arr, groupKeys, valueKeys) {
      // 将数组进行合计分组
      if (!arr || !arr.length) return null;
      let ret = [],
        tempMap = {};
      for (let i = 0, l = arr.length; i < l; i++) {
        let item = arr[i];
        let tempItem = {};
        groupKeys.forEach((key) => (tempItem[key] = item[key]));
        let key = JSON.stringify(tempItem);
        let index = tempMap[key];
        if (!index && index != 0) {
          index = ret.length;
          ret.push(tempItem);
          tempMap[key] = index;
        }
        let retItem = ret[index];
        valueKeys.forEach((key) => {
          retItem[key] = this.toNumber(
            (retItem[key] || 0) + Number(item[key] || 0)
          );
        });
      }
      return ret;
    },
    indexOfId(arr, id, idField = "ID") {
      if (this.isNull(arr)) return -1;
      for (let i = 0, l = arr.length; i < l; i++)
        if (arr[i][idField] == id) return i;
      return -1;
    },
    isImage(type) {
      return (
        ["bmp", "jpeg", "jpg", "png", "tif", "gif", "webp"].indexOf(
          type.toLowerCase()
        ) != -1
      );
    },
    isNull(obj) {
      if (obj === undefined || obj == null) return true;
      const tp = typeof obj;
      if (
        tp == "function" ||
        tp == "number" ||
        tp == "boolean" ||
        obj instanceof Date
      )
        return false;
      if (obj.length === 0) return true;
      if (typeof obj == "object") {
        for (var o in obj) return false;
        return true;
      }
      return false;
    },
    kindFileSize(size) {
      if (size != 0 && !size) return "";
      if (size < 1024) return parseInt(size) + "B";
      else if (size < 1024 * 1024) return parseInt(size / 1024) + "K";
      else return parseInt(size / 1024 / 1024) + "M";
    },
    kindTm(tm) {
      const argTm = Date.parse(new Date(this.fmtDt(tm)));
      const now = Date.parse(new Date());
      const sep = Math.round((now - argTm) / 1000 / 60);
      if (sep < 3) return "刚刚";
      // 3分钟内
      else if (sep < 60) return `${sep}分钟前`;
      // 1小时内
      else if (sep < 24 * 60) return `${Math.round(sep / 60)}小时前`;
      // 1天内
      else if (sep < 7 * 24 * 60) return `${Math.round(sep / 60 / 24)}天前`;
      // 1周内
      else if (sep < 30 * 24 * 60)
        return `${Math.round(sep / 60 / 24 / 7)}周前`;
      // 1个月内
      else if (sep < 360 * 24 * 60)
        return `${Math.round(sep / 60 / 24 / 30)}个月前`;
      // 1年内
      else return `${Math.round(sep / 60 / 24 / 360)}年前`; // 几年
    },
    now() {
      return this.parseDt(new Date(), "yyyyMMddhhmmss");
    },
    nowDate() {
      return this.parseDt(new Date(), "yyyyMMdd");
    },
    parseDt(dt, fmt) {
      // 日期类型 转换为 显示格式
      if (!dt || isNaN(dt.getTime())) return null;
      let o = {
        "M+": dt.getMonth() + 1,
        "d+": dt.getDate(),
        "h+": dt.getHours(),
        "m+": dt.getMinutes(),
        "s+": dt.getSeconds(),
        "q+": Math.floor((dt.getMonth() + 3) / 3),
        S: dt.getMilliseconds(),
      };
      if (!fmt) fmt = "yyyy-MM-dd";
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          (dt.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      }
      for (let k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length == 1
              ? o[k]
              : ("00" + o[k]).substr(("" + o[k]).length)
          );
        }
      }
      return fmt;
    },
    replaceAll(s1, s2, s3) {
      return s1.replace(new RegExp(s2, "gm"), s3 || "");
    },
    sum(list, attr, scale) {
      if (!list || list.length == 0) return 0;
      let ret = 0;
      for (let i = 0, l = list.length; i < l; i++)
        ret += Number(attr ? list[i][attr] || 0 : list[i] || 0);
      return Number(ret.toFixed(scale || 2));
    },
    toggleFullScreen() {
      let doc = window.document;
      let docEl = doc.documentElement;

      let requestFullScreen =
        docEl.requestFullscreen ||
        docEl.mozRequestFullScreen ||
        docEl.webkitRequestFullScreen ||
        docEl.msRequestFullscreen;
      let cancelFullScreen =
        doc.exitFullscreen ||
        doc.mozCancelFullScreen ||
        doc.webkitExitFullscreen ||
        doc.msExitFullscreen;

      if (
        !doc.fullscreenElement &&
        !doc.mozFullScreenElement &&
        !doc.webkitFullscreenElement &&
        !doc.msFullscreenElement
      ) {
        requestFullScreen.call(docEl);
      } else {
        cancelFullScreen.call(doc);
      }
    },
    toNumber(value, scale) {
      if (!value || isNaN(value)) return 0;
      return Number(Number(value).toFixed(scale || 2));
    },
    toTree(arr, idField = "ID", pidField = "PID") {
      const list = this.clone(arr);
      let ret = [];
      list.forEach((item) => {
        let pidValue =
          typeof item[pidField] == "object" && item[pidField]
            ? item[pidField]["ID"]
            : item[pidField];
        if (!pidValue) {
          ret.push(item);
        } else {
          var index = list.findIndex((item1) => item1[idField] == pidValue);
          if (index !== -1) {
            list[index].children = list[index].children || [];
            list[index].children.push(item);
          } else {
            ret.push(item);
          }
        }
      });
      return ret;
    },
    // 转化表单数据，将特定值转化为空字符串
    transForm(formData) {
      const copyData = JSON.parse(JSON.stringify(formData));
      const copyArr = Object.entries(copyData);
      copyArr.forEach((item) => {
        if (item[1] === "-1") {
          copyData[item[0]] = "";
        }
      });
      return copyData;
    },
    // 格式化时间
    fmtTime(val, fmt="yyyy-MM-dd") {
      if (val) {
        return this.parseDt(new Date(val), fmt);
      } else {
        return "";
      }
    },
  };
  return new Object({ ...data, ...methods });
}

export default Utility();
